const HUNDRED_YEARS_MS = 100 * 365.25 * 24 * 60 * 60 * 1000;

export function setCookie(name: string, value: string) {
  const expires = new Date(Date.now() + HUNDRED_YEARS_MS).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires};path=/;SameSite=Lax`;
}

export function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

export function removeCookie(name: string) {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
}

// Auth-specific cookie helpers
const TOKEN_KEY = "p-ai-accessToken";
const UID_KEY = "p-ai-uid";

export function setAuthCookies(token: string, userId: string) {
  setCookie(TOKEN_KEY, token);
  setCookie(UID_KEY, userId);
}

export function getAccessToken(): string | null {
  return getCookie(TOKEN_KEY);
}

export function getUserId(): string | null {
  return getCookie(UID_KEY);
}

export function clearAuthCookies() {
  removeCookie(TOKEN_KEY);
  removeCookie(UID_KEY);
}
